import { render, staticRenderFns } from "./ColorChart.vue?vue&type=template&id=2a9ba3b6&scoped=true"
import script from "./ColorChart.vue?vue&type=script&lang=ts"
export * from "./ColorChart.vue?vue&type=script&lang=ts"
import style0 from "./ColorChart.vue?vue&type=style&index=0&id=2a9ba3b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ba3b6",
  null
  
)

export default component.exports